module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Cashews.d671344f.pdf";